import FormPost from "./FormPost";

export default FormPost;
